import inventory from '@/locales/es/inventory/inventory.locales';

export default {
    ...inventory,
};
